<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="showLoadingUpdate"
      variant="dark"
      opacity="0.61"
      :blur="'2px'"
      rounded="sm"
    >
      <b-row>
        <b-col class="col-md-12 mx-auto">
          <b-col class="text-center">
            <span>Tracking status:</span><br />
            <b-badge pill variant="primary" class="p-2">{{
              trackingStatusActual.text
            }}</b-badge
            ><br />
            <md-icon :icon="'keyboard_double_arrow_down'"></md-icon>
          </b-col>
          <b-form-checkbox
            id="checkbox-1"
            class="text-center"
            v-if="trackingStatusActual.value == 'atPickup'"
            v-model="noShow"
          >
            No show
          </b-form-checkbox>
          <b-button
            v-if="!islastStatus"
            class="mt-1"
            variant="outline-primary"
            block
            @click="ConfirmStatusChangue()"
            >Actualizar a : <b>{{ trackingStatusNext.text }}</b></b-button
          >

          <b-alert
            variant="warning"
            v-if="alert != null"
            show
            class="text-center"
            dismissible
          >
            {{ alert }}
          </b-alert>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import api from "@/api.js";
import { mapMutations } from "vuex";

export default {
  props: ["itemService"],
  data() {
    return {
      noShow: false,
      showLoadingUpdate: false,
      alert: null,
    };
  },
  computed: {
    trackingStatusActual() {
      return this.$root.getItemFromAuxVarOpts(
        "transportServiceTrackingStatusOpts",
        this.itemService.trackingStatus
      );
    },
    trackingStatusNext() {
      //obtenemos las opciones de estado de aux-vars.js
      let opts = [...this.$root.auxVars.transportServiceTrackingStatusOpts];
      //obtenemos el indice las opciones recuperadas
      let indexActual = this.getIndexTracking();
      //verificamos el estado del checkbox
      if (this.noShow) {
        //buscamos la posicion de las opciones con valor:noShow
        let indexNoShow = opts.findIndex((el) => {
          return el.value == "noShow";
        });
        return opts[indexNoShow];
      } else {
        //retornamos al siguiente estado
        let nextIndex = indexActual + 1;
        return opts[nextIndex];
      }
    },
    islastStatus() {
      return (
        this.itemService.trackingStatus == "finished" ||
        this.itemService.trackingStatus == "noShow"
      );
    },
  },
  methods: {
    ...mapMutations("reservation", ["SET_UPDATE_TRANSPORT_SERVICE"]),
    getIndexTracking() {
      let opts = [...this.$root.auxVars.transportServiceTrackingStatusOpts];
      return opts.findIndex((el) => {
        return el.value == this.itemService.trackingStatus;
      });
    },
    ConfirmStatusChangue() {
      this.$bvModal
        .msgBoxConfirm("¿Esta seguro que desea cambiar el status?.", {
          title: "Confirmación",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: "Si",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: false,
        })
        .then((value) => {
          if (value === true) {
            this.DBupdateStatus();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    DBupdateStatus() {
      let filters = { transportServiceId: this.itemService.id };
      //verificamos que el estado sea finished o noshow
      if (this.islastStatus) {
        this.$root.showAlert("Opción no valida", { variant: "danger" });
        return;
      }
      //recuperamos el siguiente estado a cambiarse
      filters["trackingStatus"] = this.trackingStatusNext.value;

      this.showLoadingUpdate = true;
      this.alert = null;
      api(this)
        .post("/tracking/actions/updateStatus", filters)
        .then((res) => {
          let payload = {};
          payload = {
            index: this.getIndexTracking(),
            data: { trackingStatus: filters["trackingStatus"] },
          };
          this.SET_UPDATE_TRANSPORT_SERVICE(payload);

          this.$root.showAlert("Realizado con exito");
          if ("alert" in res.data) {
            console.log("alert");
            this.alert = res.data.alert[0];
          } else {
            console.log("no alert");
            this.alert = null;
            this.$emit("closeModal");
          }
        })
        .catch(this.$root.handleRequestError)
        .finally(() => {
          this.showLoadingUpdate = false;
        });
    },
  },
};
</script>

<style>
</style>
